import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ContextService } from '../context.service';

export interface NavigationDefintion {
  ID: number,
  parent?: number,
  img?: string,
  title: string,
  route: string,
  properties?: string,
  depth?: number
}
@Component({
    selector: 'mutara-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {
  definitions: any;
  navigationList: NavigationDefintion[] | undefined;
  flatHierarchy = [];

  isEditable = true;
  //@Input() source: string;

  constructor(private http: HttpClient,
    private context: ContextService
  ) { }

  ngOnInit(): void {
    /*
    this.context.currentNavigation.subscribe((source) => {
      if (!!source) {
          this.http.get('$service/navigation', { params: { name: source } }).subscribe(
          (data: NavigationDefintion[]) => {
            this.__processNavigation(data);
          });
      } else {
        this.__processNavigation( [] );
      }
    });
    */
  }

  /**
   * flatten hierarchy into list
   * @param stack 
   * @param node 
   */
  __addChildren(stack : any[], node : any) {
    if (!!node) {
      stack.push(node.ID);
      node.children.forEach((child : any) => {
        child.depth = node.depth + 1;
        this.__addChildren(stack, child);
      });
    }
  }
  /** Build the parent/child object as well as the flattened version for drag/drop */
  __processNavigation(data : any[]) {

    let newTree : any = {}, list: NavigationDefintion[] = [], index = 0;
    /// Ok, convert from flat to parent child and flip the raw links to href/target
    data.forEach(row => {
      // If no parent, add to the index and children array
      if (!row.parent) {
        list.push(newTree[row.ID] = Object.assign(row, { children: [], index: index++ }));
      } else {
        // Add children array, and push into parent's children (can be multiple)
        data.filter(obj => { return obj.ID === row.parent; }).forEach(parent => {
          newTree[parent.ID].children.push(Object.assign(row, { children: [], index: index++ }));
        });
      }
    });
    // This nested structure needs to be flattened using a second array
    this.flatHierarchy = [];
    list.forEach((node) => {
      node.depth = 0;
      this.__addChildren(this.flatHierarchy, node);
    });

    // Change the definitions to match
    this.definitions = list;
  }

  isRoute(route : string | undefined) {
    return !!route && route.startsWith('/');
  }

 
  /**
   * WIP - EDITOR
   * @param event 
   */
  drop(event: CdkDragDrop<string[]>) {

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }
}
